export default __webpack_public_path__ + "static/mais-tempo-para-o-bem-2-5b67418e6fd97dc9ae8f33ae4f442c33.png";